module.exports = __webpack_public_path__ + "img/fb00614a5dc62bbd83a4098b326d7617.e6f774ab.png";